<template>
    <GChart ref="chart"
            type="PieChart"
            :data="valores_entradas_vendidas_grafica"
            :options="chartOptions"
    />
</template>

<script>

    export default {
        name: "VentasNormalesAbonosComponent",
        props: ['event_id', "informe_ventas_normal_abonos"],
        data() {
            return {
                valores_entradas_vendidas_grafica : [
                    ['Tipo', 'Cantidad'],
                    ['Normal', 0],
                    ['Abonado', 0],
                    ['Amigos Abonados', 0]
                ],
                chartOptions: {
                    height: 250,
                    chartArea:{width:'100%'}
                }
            }
        },
        created() {
            this.setValoresEntradasNormalesAbonosVendidas(this.informe_ventas_normal_abonos);
        },
        methods: {
            render() {
                this.$refs["chart"].drawChart();
            },
            setValoresEntradasNormalesAbonosVendidas(entradas) {
                this.valores_entradas_vendidas_grafica[1][1] = entradas.normal;
                this.valores_entradas_vendidas_grafica[2][1] = entradas.abonado;
                this.valores_entradas_vendidas_grafica[3][1] = entradas.amigos_abonados;
            },
        },
    }
</script>